export default __webpack_public_path__ + "static/media/car10.71bae943.jpg";